import "../../style/credit-report.css"; // I
import React, { useState, useEffect, Fragment } from "react";
import AllVerification from "../../component/AllVerification";
import axios from "axios";
import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Spinner,
  Button,
  Text,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Stack,
  FormErrorMessage
} from "@chakra-ui/react";
import { Auth } from "../../component/Auth";
import AllFillters from '../../component/Layout/AllFillters';
import { JsonViewer } from '@textea/json-viewer'
function CustomerVerified() {
  const [tData, setTData] = useState([]);
  const [isLoading, setIsLoading] = useState({ loading: true, error: false });
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [report, setReport] = useState({})
  const [isFetching, setIsFetching] = useState(false);
  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order?status=ORDER_VERIFIED`,
      headers: {
        Authorization: Auth(),
      },
    };

    axios
      .request(config)
      .then((response) => {
        setTData(response.data);
        setIsLoading({ loading: false, error: false });
      })
      .catch((error) => {
        console.log("error-getting-verified-order");
        setIsLoading({ loading: false, error: true });
      });
  }, []);

  const uuid = () => {
    let dt = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === "x" ? r : (r & 0x7) | 0x8).toString(16);
      }
    );
    return uuid;
  };

  const validateName = (name) => {
    if (!name) {
      setNameError("Name is required");
      return false;
    }
    
    setNameError("");
    return true;
  };

  const validateMobile = (mobile) => {
    if (!mobile) {
      setMobileError("Mobile number is required");
      return false;
    }
    if (!/^\d{10}$/.test(mobile)) {
      setMobileError("Invalid mobile number");
      return false;
    }
    setMobileError("");
    return true;
  };

  const handleSubmit = (e) => {
    if (isFetching) return;
    
    e.preventDefault();
    if (validateMobile(mobile) && validateName(name)) {
      setIsFetching(true);
      fetchReport();
    }
  };

  const fetchReport = () => {
    const params = {
      reference_id: uuid(),
      consent: true,
      consent_purpose: "For bank account purpose only",
      name: name,
      mobile: mobile,
      inquiry_purpose: "PL"
    };

    // const url = `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/credit-report-for-admin`
    // "https://zvvl85zawf.execute-api.ap-south-1.amazonaws.com/api/decentro/credit-report-for-admin"
    // const url =
    //   "https://gab15hbkel.execute-api.ap-south-1.amazonaws.com/api/decentro/credit-report-for-admin";
      // const url = "https://zvvl85zawf.execute-api.ap-south-1.amazonaws.com/api/decentro/credit-report-for-admin"
      const url = "https://api.equipp.in/api/decentro/credit-report-for-admin"

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then((data) => {
        setReport(data.data);
        setIsFetching(false);
      })
      .catch((error) => {
        console.error("Error:", error)
        setIsFetching(false);
      } );
  };

  return (
    <Fragment>
      <Box p={5} flex="1" w={'100%'}>
        <Heading fontSize={{base: '20px', md: '20px', lg: '27px', xl: '27px', '2xl': '27px'}} mb={0} >Credit Report</Heading>
        <form onSubmit={handleSubmit}>
          <Stack spacing={3} mt={5}>
            <FormControl id="name" isInvalid={nameError}>
              <FormLabel>Full Name as per Pan</FormLabel>
              <Input type="text" value={name} onChange={(e) => setName(e.target.value)} />
              <FormErrorMessage>{nameError}</FormErrorMessage>
            </FormControl>
            <FormControl id="mobile" isInvalid={mobileError}>
              <FormLabel>Mobile Number</FormLabel>
              <Input type="text" value={mobile} onChange={(e) => setMobile(e.target.value)} />
              <FormErrorMessage>{mobileError}</FormErrorMessage>
            </FormControl>
            <div style={{marginTop: '20px',display: 'flex'}}>
            <Button 
            colorScheme="blue"
            size="lg"
            
            disabled={isFetching} type="submit">Submit</Button>
            </div>
          </Stack>
        </form>
        
        {
          isFetching && <Spinner style={{marginTop: '20px'}}/>
        }

        { !isFetching && report && <CreditData data={report} />}
      </Box>
    </Fragment>
  );
};


function CreditData({ data }) {
  if (!data.cCRResponse) return (
    <Box p={5} flex="1" w={'100%'}>
      <Text>No data available</Text>
    </Box>
  )
  const scoreDetails = data?.cCRResponse?.cIRReportDataLst[0]?.cIRReportData?.scoreDetails[0];
  const iDAndContactInfo = data?.cCRResponse?.cIRReportDataLst[0]?.cIRReportData?.iDAndContactInfo;
  const addressInfo = iDAndContactInfo?.addressInfo[0];
  const emailAddressInfo = iDAndContactInfo?.emailAddressInfo ? iDAndContactInfo?.emailAddressInfo[0] : {};
  const identityInfo = iDAndContactInfo?.identityInfo;
  const personalInfo = iDAndContactInfo?.personalInfo;
  const phoneInfo = iDAndContactInfo?.phoneInfo;

  const error = data?.cCRResponse?.cIRReportDataLst[0]?.error
  if (error) return (
    <Box style={{marginTop: '30px', color: 'red'}} flex="1" w={'100%'}>
      <Text>{error.errorDesc}</Text>
    </Box>
  )

  return (
    <div style={{marginTop: '30px'}}>
      <Heading  style={{marginBottom: '30px'}} fontSize={{base: '10px', md: '10px', lg: '19px', xl: '19px', '2xl': '19px'}} mb={0} >Credit Report Result</Heading>
    <table className="credit-data-table">
      <tbody>
        <tr>
          <td colSpan="2">
            <strong>Credit Score</strong>
          </td>
          <td colSpan="2">
            {scoreDetails?.value}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>Address</strong>
          </td>
          <td colSpan="2">
            {addressInfo?.address}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>postal</strong>
          </td>
          <td colSpan="2">
            {addressInfo?.postal}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>State</strong>
          </td>
          <td colSpan="2">
            {addressInfo?.state}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>Email</strong>
          </td>
          <td colSpan="2">
            {emailAddressInfo?.emailAddress}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>Pan</strong>
          </td>
          <td colSpan="2">
            {identityInfo?.pANId ? identityInfo?.pANId[0]?.idNumber : ''}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>Name</strong>
          </td>
          <td colSpan="2">
            {personalInfo?.name.fullName}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>Occupation</strong>
          </td>
          <td colSpan="2">
            {personalInfo?.occupation}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>Gender</strong>
          </td>
          <td colSpan="2">
            {personalInfo?.gender}
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <strong>DOB</strong>
          </td>
          <td colSpan="2">
            {personalInfo?.dateOfBirth}
          </td>
        </tr>
        {
          phoneInfo && phoneInfo.map((phone, index) => (
            <tr key={index}>
              <td colSpan="2">
                <strong>Phone({index}) </strong>
              </td>
              <td colSpan="2">
                {phone.number} (reported date: {phone.reportedDate})
              </td>
            </tr>
          ))
        }
      </tbody>

    </table>
    <JsonViewer value={data} />
    
    </div>
  );
}


export default CustomerVerified;

